import React from 'react';
import { SvgIcon } from '@material-ui/core';

const CubeIcon = props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 2.5l8.23 4.75v9.5L12 21.5l-8.23-4.75v-9.5zM12 12L3.77 7.25M12 12l8.23-4.75M12 12v9.5"
    />
  </SvgIcon>
);

export default CubeIcon;
